import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const BookingSuccess: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { appointmentId, trackingCode, formData } = location.state || {};
  const displayTrackingCode = trackingCode || formData?.tracking_code || (appointmentId ? String(appointmentId) : '-');

  const primaryButtonClass = 'inline-flex items-center justify-center rounded-lg bg-gray-900 text-white py-3 px-4 text-sm font-medium transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-300';
  const secondaryButtonClass = 'inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white text-gray-800 py-3 px-4 text-sm font-medium transition-colors hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300';

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-sm mx-auto">
          <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
            {/* Success Icon */}
            <div className="text-center mb-6">
              <div className="mx-auto mb-4">
                {/* Animated checkmark */}
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-600 rounded-full shadow-md">
                  <svg className="w-8 h-8 text-white animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{animation: 'bounce 1s ease-in-out'}}>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                نوبت شما با موفقیت ثبت شد!
              </h2>
              <p className="text-sm text-gray-600">
                شماره پیگیری: <span className="font-medium text-gray-900">{displayTrackingCode}</span>
              </p>
              <p className="text-sm text-gray-600 mt-2">
                دوستان ما بزودی با شما تماس خواهند گرفت
              </p>
            </div>

            {/* Appointment Details */}
            <div className="space-y-3 mb-6">
              <h3 className="text-sm font-medium text-gray-700 mb-3">جزئیات نوبت</h3>
              
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <span className="text-sm text-gray-600">نام:</span>
                <span className="text-sm font-medium text-gray-800">
                  {formData?.full_name}
                </span>
              </div>
              
              <div className="flex justify-between items-center py-2 border-b border-gray-100">
                <span className="text-sm text-gray-600">شماره تماس:</span>
                <span className="text-sm font-medium text-gray-800">{formData?.phone}</span>
              </div>
            </div>

            {/* Important Notes */}
            <div className="bg-blue-50 rounded-lg p-4 mb-6">
              <h4 className="text-sm font-medium text-blue-900 mb-2">
                نکات مهم:
              </h4>
              <ul className="text-xs text-blue-800 space-y-1">
                <li>• شماره پیگیری را یادداشت کرده و برای پیگیری‌های بعدی نگه دارید</li>
                <li>• 15 دقیقه قبل از نوبت در مرکز حضور داشته باشید</li>
                <li>• کارت ملی و مدارک پزشکی همراه داشته باشید</li>
                <li>• در صورت عدم امکان حضور، 24 ساعت قبل اطلاع دهید</li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3">
              <button
                onClick={() => navigate('/')}
                className={`${secondaryButtonClass} flex-1`}
              >
                صفحه اصلی
              </button>
              <button
                onClick={() => navigate('/booking')}
                className={`${primaryButtonClass} flex-1`}
              >
                نوبت جدید
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
